<template>
    <div>
        <ion-toolbar>
            <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
                <ion-button class="button_back" @click="goBack">
                    <ion-icon name="arrow-back-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-buttons slot="end" v-if="$route.name == 'auth_birthday'">
                <ion-button class="pill next-pill-button" @click="skip">
                    <span>Skip</span>
                </ion-button>
            </ion-buttons>
        </ion-toolbar>

        <div class="main_wrapper ion-padding">
            <div class="container">
                <page-title
                    v-if="isRegion('US')"
                    title="Date of Birth"
                    subtitle="We need your date of birth to verify your registration with License Number"
                    showIcon
                />
                <page-title
                    v-else
                    title="Date of Birth"
                    subtitle="We need your date of birth to verify your registration with AHPRA!"
                    showIcon
                />
                <el-form
                    class="full_page"
                    :model="formsData.userForm"
                    :rules="formsData.userForm.rules"
                    :ref="(el) => (formsData.userForm.ref = el)"
                    :label-position="'top'"
                    @submit.prevent="goNext('userForm')"
                >
                    <el-form-item class="no-scroll" prop="birthday" :required="true">
                        <el-date-picker
                            popper-class="datepicker_popper drawer-style"
                            v-model="formsData.userForm.birthday.valueFormatted"
                            type="date"
                            class="dob_picker"
                            :placeholder="$filters.systemDateFormat()"
                            :format="$filters.systemDateFormat()"
                            :editable="true"
                            :disabled-date="formsData.userForm.birthday.disabledDate"
                            @change="dateConvert"
                            @input="handleInput"
                            @keyup="handleInput"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="button_submit button_submit mb0">
                        <el-button
                            class="submit"
                            type="blue"
                            @click="goNext('userForm')"
                            :disabled="formsData.userForm.disabled"
                        >
                            Continue 
                        </el-button>
                    </el-form-item>
                </el-form>
                <div class="background-circles" v-if="isAustralia">
                    <div class="circle circle-2"></div>
                    <div class="circle circle-1"></div>
                    <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
                </div>

            </div>
            <!-- <div class="bg-overlay"></div> -->
        </div>
    </div>
</template>

<script>
import './Birthday.scss';
import { ElMessageBox } from "@/components/Vendor/Element";
import { onMounted, inject, computed, watch, getCurrentInstance } from "vue";
import PageTitle from '@/components/PageTitle/PageTitle.vue';
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { IMask } from 'imask';
import { useStore } from "vuex";

import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 
import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        PageTitle,
        SvgIcon
    },
    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const $moment = inject(["$moment"]);
        const isAustralia = isAustraliaRegion();
        const userData = $store.getters.GET_USER_DATA;
        const instance = getCurrentInstance();

        const isRegion = (region) => {
            return computed(() => process.env.VUE_APP_REGION === region);
        };

        // Watcher to apply mask when date input changes
        watch(
        () => formsData.userForm.birthday.valueFormatted,
        (newDate) => {
            if (newDate) {
            // Set up mask for 'MM/DD/YYYY' format
            const maskOptions = { mask: `${instance?.appContext.config.globalProperties.$filters.systemDateFormat() }` };
            const masked = IMask.createMask(maskOptions);
            formsData.userForm.birthday.valueFormatted = masked.resolve(newDate) || '';
            }
        }
        );

        const dateConvert = () => {
            if (formsData.userForm.birthday.valueFormatted) {
                const result = $moment(formsData.userForm.birthday.valueFormatted, "YYYY-MM-DD").format(
                    "YYYY-MM-DD")
                formsData.userForm.birthday.value = result
            } else {
                formsData.userForm.birthday.value = ''
                return null;
            }
        };

        const handleInput = (value) => {
            formsData.userForm.birthday.value.valueFormatted = value;
            dateConvert(); // Update the value based on input
        };

        const birthdayValue = userData.birthday
            ? $moment(userData.birthday, ["YYYY-MM-DD"])
            : null;

        const formsDataArray = {
            userForm: {
                ref: null,
                birthday: {
                    value: null,
                    // valueFormatted: null,
                    // disabledDate: null,
                    // value: dateConvert || $moment(birthdayValue).format("YYYY-MM-DD"),
                    valueFormatted: birthdayValue,
                    // disabledDate: (time) => {
                    //     let dateNow = new Date().setFullYear(new Date().getFullYear() - 18);
                    //     return (
                    //         time.getTime() >
                    //             new Date(dateNow).setDate(new Date(dateNow).getDate())
                    //     );
                    // },
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "birthday",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };

        const goBack = async() => {
            const back = await $store.dispatch("getAuthPageBack");
            $router.push({
                name: back,
            });           
        };

        const goNext = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            await $store.dispatch("SAVE_USER_DATA", getFormValues(formName));
                            if (process.env.VUE_APP_REGION === 'US') {
                                $router.push({
                                    name: "auth_address",
                                });
                            } else {
                                $router.push({
                                    name: "auth_gender",
                                });
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    if (process.env.VUE_APP_REGION === 'US') {
                        $router.push({
                            name: "auth_address",
                        });
                    } else {
                        $router.push({
                            name: "auth_gender",
                        });
                    }

                } catch (error) {
                    console.log(error);
                }
            })();
        };

        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            setFormRefs();
            checkFormValidation("userForm", false);
        });

        const {
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            dateConvert,
            formsData,
            goBack,
            goNext,
            skip,
            isRegion,
            isAustralia,
            handleInput,
            instance
        };
    },
};
</script>